// For QR register attendance
export const REGISTER_ATTENDANCE_SCHOOL_ID = "RegisterAttendanceSchoolId";
export const REGISTER_ATTENDANCE_CLASS_ID = "RegisterAttendanceClassId";
export const SUPPORT_PHONE_NUMBER = '888-710-5819'